import { useState } from 'react';
import { faqs } from '@/mocks/animeData';

export default function Faq() {
  const [open, setOpen] = useState<string | null>(faqs[0].q);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-900">
            <i className="ri-question-line"></i>常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">追更之前，先看这里</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
            关于内容更新、剧透范围与投稿方式的常见疑问，一次讲清楚。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f) => {
            const isOpen = open === f.q;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                  isOpen ? 'border-primary-200' : 'border-background-200'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : f.q)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <h3 className="text-sm font-bold text-foreground-950 md:text-base">{f.q}</h3>
                  <span
                    className={`flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                    }`}
                  >
                    <i className={`text-sm ${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </span>
                </button>
                {isOpen && <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}